import { Injectable } from '@angular/core';
import { BehaviorSubject, interval, Observable, Subscription } from 'rxjs';
import { MembershipApiService } from './API/membership-api.service';
import { AuthenticationService } from './authentication.service';
import { MembershipExpiryModel } from '../common/models/MemberAccess/MembershipExpiryModel';
import { switchMap } from 'rxjs/operators';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class MembershipService {
  private membershipExpirationSubject = new BehaviorSubject<MembershipExpiryModel>(null);
  private expirationCheckSub: Subscription;
  private dialogRef: any;
  membershipExpiration$ = this.membershipExpirationSubject.asObservable();

  constructor(private membershipapiservice: MembershipApiService, private authenticationService: AuthenticationService, private router: Router) { }

  public async init() {
    try {
      const customerId = this.authenticationService.getUser().CustomerId;
      const data = await this.membershipapiservice
        .getMembershipExpiration(customerId)
        .toPromise();
      this.membershipExpirationSubject.next(data);
    }
    catch (e) {
      this.membershipExpirationSubject = null;
    }
  }

  public getMembershipExpirationObj(): MembershipExpiryModel {
    return this.membershipExpirationSubject.value;
  }

  public getRemainingDays(): number {
    const exp = this.membershipExpirationSubject.value;
    return exp ? exp.remainingDays : 0;
  }

  public getExpireDate(): Date {
    const exp = this.membershipExpirationSubject.value;
    return exp ? exp.expireDate : null;
  }

  public isMembershipExpired(): boolean {
    const exp = this.membershipExpirationSubject.value;
    return exp ? exp.remainingDays < 0 : true;
  }

  startExpirationWatch() {
    const customerId = this.authenticationService.getUser().CustomerId;

    this.expirationCheckSub = interval(2000)
      .pipe(
        switchMap(() =>
          this.membershipapiservice.getMembershipExpiration(customerId)
        )
      )
      .subscribe(data => {
        console.log("Polling data:", data);
        this.membershipExpirationSubject.next(data);

        if (!this.isMembershipExpired()) {
          this.stopExpirationWatch();
          if (this.dialogRef?.close) {
            this.dialogRef.close();
          }
          window.location.reload();
        }
      });
  }

  stopExpirationWatch() {
    if (this.expirationCheckSub) {
      this.expirationCheckSub.unsubscribe();
      this.expirationCheckSub = null;
    }
  }
  // New method: fetch membership expiration and update subject
  private async loadExpireDate() {
    const customerId = this.authenticationService.getUser().CustomerId;
    const data = await this.membershipapiservice.getMembershipExpiration(customerId).toPromise();
    if (data) {
      this.membershipExpirationSubject.next(data);
    }
  }

  // New method: refresh expiry date twice - immediately and after 10 sec
  public refreshExpireDateWithDelays() {
    // 1st request immediately
    this.loadExpireDate();

    // 2nd request after 10 seconds
    setTimeout(() => {
      this.loadExpireDate();
    }, 5000);
  }
}
